import { svg } from 'lit';

const symbol = svg`<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 2L9 7L14 2" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4 9L9 14L14 9" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export { symbol as default };

